export enum EBroadcastCustomerRestrictionsQueryKey {
  BROADCAST_RESTRICTIONS = 'broadcast-restrictions'
}
